import ErrorBoundary from 'Components/ErrorBoundary/disona/ErrorBoundaryDisona';
import InstallApp from 'Components/InstallApp';
import React, { useEffect } from 'react';
import { BREAKPOINTS } from 'themes/media';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { useWindowSize } from 'common/utils/style.util';
import { hideFcButton, showFcButton } from 'initFreshChat';
import Sidebar from 'Components/AppLayout/disona/Components/Sidebar';
import { MenuModal } from 'Components/AppLayout/disona/Components/MenuModal';
import * as S from './styled';
import Header from './Components/Header';

function AppLayoutDisonaRaw({
  children,
  contentBackground,
  contentContainerRef,
  sidebarRef,
  containerRef,
  menuProps = {},
  ProfileStore,
  pageName,
}) {
  const windowW = useWindowSize().width;
  useEffect(() => {
    if (ProfileStore.isInitedFreshChat) {
      if (windowW >= BREAKPOINTS.desktop) {
        showFcButton();
      } else {
        hideFcButton();
      }
    }
  }, [windowW, ProfileStore.isInitedFreshChat]);
  return (
    <S.Layout ref={containerRef}>
      <MenuModal />
      <Sidebar ref={sidebarRef} />
      <Header {...menuProps} pageName={pageName} />
      <S.Content
        ref={contentContainerRef}
        id="AppLayoutContent"
        background={contentBackground}
      >
        <ErrorBoundary>{children}</ErrorBoundary>
      </S.Content>
      <InstallApp />
    </S.Layout>
  );
}

export const AppLayoutDisona = inject('ProfileStore')(
  observer(AppLayoutDisonaRaw)
);
